import React, {useState, useEffect} from 'react'
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';

const AirbnbSlider = styled(Slider)(({ theme }) => ({
    color: '#2FB9A7',
    height: 3,
    padding: '13px 0',
    '& .MuiSlider-thumb': {
      height: 27,
      width: 27,
      backgroundColor: '#fff',
      border: '1px solid currentColor',
      '&:hover': {
        boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
      },
      '& .airbnb-bar': {
        height: 9,
        width: 1,
        backgroundColor: 'currentColor',
        marginLeft: 1,
        marginRight: 1,
      },
    },
    '& .MuiSlider-track': {
      height: 3,
    },
    '& .MuiSlider-rail': {
      color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#2FB9A7',
      opacity: theme.palette.mode === 'dark' ? undefined : 1,
      height: 3,
    },
}));

function AirbnbThumbComponent(props) {
    const { children, ...other } = props;
    return (
      <SliderThumb {...other}>
        {children}
        <span className="airbnb-bar" />
        <span className="airbnb-bar" />
        <span className="airbnb-bar" />
      </SliderThumb>
    );
}

const getIntsString = (rangeString) => rangeString?.split("-").map(n => parseInt(n))

export default function RangeSlider({filter, onFacetChange}) {
    if(!filter)
      return <></>

    filter.options = filter.options.filter(option => option.label != "0-0")

    const rangeString = filter?.options?.length > 1 ? 
        filter?.options.find(x => !filter.selectedOptions?.includes(x.id)).id :
        filter?.options[0]?.id

    const currentValue = filter?.selectedOptions[0]
    const range = getIntsString(rangeString)
    const [value, setValue] = useState(
        currentValue == null ? getIntsString(rangeString) : getIntsString(currentValue)
    )

    useEffect(() => {
      if(range == null || value == null)
        return

      // Automatically reset price filter if no hits
      if(range[0] == 0 && range[1] == 0 && currentValue) {
        onFacetChange(filter, "0-0", true, null, true)
        return
      }

      if((range[1] < value[1] || range[0] > value[1]) && currentValue) {
        setValue(range)
        onFacetChange(filter, "0-0", true, null, true)
        return
      }

      if(!currentValue) {
        setValue(range)
      }
    }, [filter])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeCommited = () => {
        const rangeAsString = `${value[0]}-${value[1]}`
        if(!filter.options.find(x => x.id == rangeAsString)) {
            filter.options.push({
                label: rangeAsString,
                id: rangeAsString
            })
        }

        onFacetChange(filter, rangeAsString, true, null, true)
    }

    if(range == null)
      return <></>

    return (
        <div className="range-slider-container">
            <AirbnbSlider
                components={{ Thumb: AirbnbThumbComponent }}
                min={range[0]}
                max={range[1]}
                value={value}
                onChange={handleChange}
                valueLabelDisplay="on"
                onChangeCommitted={handleChangeCommited}
            />
        </div>
    )
}

